module.exports = __webpack_public_path__ + "img/diyCardTitleHor.854580ab.png";